{
  "commonHeader": {
    "upgradeToPro": "アップグレード",
    "learnMore": "詳細はこちら",
    "AIProductivitySuite": {
      "title": "AI 生産性スイート",
      "desc": "ひらめきに満ちた議論を、印象的な成果物へと変えましょう。"
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "AI で組織のアカウントを管理",
        "description": "アカウントに関する質問へのインテリジェントな回答と、設定の操作サポートを利用できます。",
        "terms": "Zoom のベータ機能を使用すると、{0} に同意したものとみなされます",
        "termsText": "Zoom ベータ プログラム規約"
      },
      "diveDeeper": "さらに詳しく",
      "shareFeedback": "{0}でフィードバックを共有",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "組織のアカウントについて質問する",
      "heroInvite": "アカウントに新しいユーザーを招待するには？",
      "heroGroups": "ユーザーをグループに割り当てるには？",
      "heroRoles": "役割と権限の管理方法を教えてください"
    },
    "backMainAccount": "メインアカウントに戻る",
    "discoverProducts": "製品を探す",
    "pricing": "料金",
    "more": "その他",
    "sidebarExpanded": "展開済み",
    "sidebarCollapsed": "折りたたみ済み",
    "search": "検索",
    "users": "ユーザー",
    "settings": "アカウント設定",
    "navigation": "ナビゲーション",
    "clear": "クリア",
    "searchPlaceholderAll": "ユーザー、アカウント設定、またはナビゲーションを検索",
    "searchPlaceholderUsers": "ユーザーまたはナビゲーションを検索",
    "searchPlaceholderSettings": "アカウント設定またはナビゲーションを検索",
    "searchPlaceholderNav": "ナビゲーションを検索",
    "searchGuide": "キーワードを入力して検索を開始",
    "installOnDesktop": "デスクトップにインストール",
    "downloadCenter": "ダウンロードセンター",
    "getInTouch": "お問い合わせ",
    "featuredProduct": "注目の製品",
    "logo": {
      "adminCenter": "管理センター",
      "subAccount": "サブアカウントを管理中",
      "externalAccount": "委任アカウントを管理中"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "詳細情報",
      "gotIt": "了解"
    },
    "coachMark": {
      "dvsTipsTitle": "ディビジョンが利用可能になりました",
      "dvsTipsContent": "ディビジョンを使用すると、アカウント内で特定の Zoom 製品の複数のインスタンスを作成できます。"
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "詳細情報",
      "gotIt": "了解"
    },
    "coachMark": {
      "extAccountTipsTitle": "外部アカウントを管理",
      "extAccountTipsContent": "別のアカウントを管理する必要がありますか？リクエストを送信するだけです。承認されると、すぐに管理を開始できます。"
    }
  },
  "feedback": {
    "dialogTitle": "フィードバックを送信",
    "itemLableForProductArea": "プロダクト領域",
    "itemLableForSatisfied": "今回の体験に、どの程度ご満足いただけたでしょうか？",
    "dissatisfied": "非常に不満",
    "satisfied": "非常に満足",
    "itemLableForFeedback": "フィードバック",
    "placeholder": "ぜひアイディア、コメント、提案などをお寄せください。",
    "btnCancel": "キャンセル",
    "btnSubmit": "送信",
    "supportTips": "技術サポートが必要な場合は、以下にアクセスしてください:",
    "btnSupport": "サポート:",
    "messages": {
      "success": "フィードバックをお寄せいただきありがとうございます。",
      "productFailed": "プロダクト領域は必須です。",
      "scoreFailed": "満足度スコアは必須です。"
    },
    "products": {
      "General": "一般",
      "AI": "AI",
      "Apps": "アプリ",
      "Calendar": "カレンダー",
      "Clips": "Clips",
      "ContactCenter": "コンタクトセンター",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "メール",
      "Meetings": "ミーティング",
      "Notes": "メモ",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Scheduler",
      "Tasks": "タスク",
      "TeamChat": "チームチャット",
      "WebinarsAndEvents": "ウェビナーとイベント",
      "Whiteboard": "ホワイトボード",
      "WorkflowAutomations": "ワークフロー自動化",
      "WorkspaceReservation": "ワークスペース予約",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "この免責事項はアカウント管理者により生成されました。",
    "cancel": "キャンセル",
    "agree": "同意する"
  },
  "shared": {
    "sideMenu": {
      "personal": "個人",
      "admin": "管理者",
      "menu": "メニュー",
      "pinned": "ピン留め済み",
      "pin": "ピン留め",
      "unpin": "ピン留めを解除",
      "moveItem": "項目を移動",
      "myAccount": "マイアカウント",
      "upgradeToPro": "Proにアップグレード",
      "grabbedKeyboard": "{0}をつかみました。上下矢印キーで移動し、スペースまたはEnterでドロップします。",
      "dropped": "{0}をドロップしました。",
      "releasedUnchanged": "{0}を解放しました。位置は変更されていません。",
      "movedToPosition": "{0}を{2}件中{1}番目に移動しました。",
      "movedUp": "{0}を上に移動しました。現在の位置は{2}件中{1}番目です。",
      "movedDown": "{0}を下に移動しました。現在の位置は{2}件中{1}番目です。",
      "movedUpNew": "{0}を上に移動しました。新しい位置は{2}件中{1}番目です",
      "movedDownNew": "{0}を下に移動しました。新しい位置は{2}件中{1}番目です",
      "cannotMoveFurther": "{0}はこれ以上移動できません。",
      "grabbedMouse": "{0}をつかみました。マウスを動かして位置を変更し、クリックでドロップ、Escでキャンセルします。"
    },
    "item": "項目",
    "gotIt": "了解",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "電話番号を正常に追加しました。今後のサインインやアカウントの復元で使用できるようになりました。",
    "mfa_to_signin_phone_success": "{phone} が {email} のサインイン用番号に設定されました。",
    "login_passkey_bound_success": "パスキーが正常に作成されました"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "以下の詳細管理機能はライセンス ユーザーとコラボレーション ユーザーにのみ適用されます",
      "licensed_basic": "以下の詳細管理機能はライセンス ユーザーとベーシック ユーザーにのみ適用されます",
      "licensed": "以下の詳細管理機能はライセンス ユーザーにのみ適用されます"
    },
    "support": "- アカウント設定とユーザー グループ設定でサポートされます",
    "archive_product": {
      "title": "ミーティングとウェビナーをアーカイブする",
      "detail": "- ミーティングは、アカウント内のユーザーが参加するとアーカイブされます。この設定を使用するには、Zoom App Marketplace から<a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">アーカイブ アプリ</a>をインストールしてください。"
    },
    "restrict": {
      "title": "ユーザーがミーティングに参加するときに、選択されている機能をユーザーが使用するのを制限します",
      "detail": "- 選択した機能は、ミーティング ホストがミーティングに対して有効に設定する場合でも利用できません。"
    },
    "meeting_integration": {
      "title": "ミーティング内チャット DLP（データ損失防止）連携を有効にする",
      "detail": "- オンにすると、参加者が送信する公開チャット メッセージと非公開チャット メッセージの両方に DLP が適用されます。内部または外部ミーティングの参加者がチャットを行っているときにホストの組織のコンプライアンス ポリシーに違反したメッセージが出現した場合、そのメッセージはすぐに削除されます。"
    },
    "chat_tool": {
      "title": "チャット エチケット ツール",
      "detail": "- 定義済みのキーワードとテキスト パターンを共有コンテンツで特定し、ユーザーが望ましくないメッセージを共有するのを防ぎます"
    },
    "information_barriers": {
      "title": "情報障壁",
      "detail": "- 情報保護機能は、コンプライアンス上の目的で特定のユーザー間のコミュニケーションを制御するものです。ミーティングとチャットの制限は、2 つのグループのユーザー間や、特定の機能（ミーティング内チャット、画面の共有、ファイル転送など）を使用する特定のユーザーに対して設定できます。これらの制限により、権限のないユーザー間で秘匿性の高い情報が交換されるのを防ぐことができます。"
    },
    "dashboard": {
      "title": "ダッシュボード",
      "detail": "- [ミーティング] > [過去のミーティング] ダッシュボードでは、一部のユーザーについては 3 か月間のデータしか表示されません"
    },
    "reports": {
      "title": "レポート",
      "detail": "- 一部のユーザー レポート（免責事項レポート、出席者ログレポート、管理者アクティビティ ログ レポート、サインイン/サインアウト レポートなど）には、そのユーザーの 3 か月間のデータしか表示されません"
    },
    "close": "閉じる"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "{planName} は {cancelDate} にキャンセルされます。この日までは、ウェビナーライセンスを再有効化できます。{supportStartDate} から {supportEndDate} までは、カスタマーサポートに連絡して既存のウェビナーデータを取得できます。{dataLossDate} 以降、ウェビナーのデータはすべて失われます。",
            "nonAdmin": "{planName} は {cancelDate} にキャンセルされます。この日までにアカウント管理者に連絡して、ウェビナーライセンスを再有効化できます。{supportStartDate} から {supportEndDate} までは、カスタマーサポートに連絡して既存のウェビナーデータを取得できます。{dataLossDate} 以降、お使いのアカウントのウェビナーのデータはすべて失われます。"
          },
          "admin": "{planName} は {cancelDate} にキャンセルされます。この日までは、ウェビナーのライセンスを再有効化できます。{supportStartDate} から {supportEndDate} までは、カスタマーサポートに連絡して既存のウェビナーの {supportContent} を取得できます。{dataLossDate} 以降、お使いのアカウントのウェビナーのデータはすべて失われます。",
          "nonAdmin": "{planName} は {cancelDate} にキャンセルされます。この日までにアカウント管理者に連絡して、ウェビナーライセンスを再有効化できます。{supportStartDate} から {supportEndDate} までは、カスタマーサポートに連絡して既存のウェビナーの {supportContent} を取得できます。{dataLossDate} 以降、お使いのアカウントのウェビナーのデータはすべて失われます。"
        },
        "expired": {
          "admin": "{planName} はキャンセルされました。{supportStartDate} から {supportEndDate} までは、既存のウェビナーの {supportContent} を取得するためにカスタマーサポートに連絡するか、Zoom Webinarsを再度購入することでデータアクセスを復元できます。{dataLossDate} 以降、お使いのアカウントのウェビナーのデータはすべて失われます。",
          "nonAdmin": "{planName} はキャンセルされました。{supportStartDate} から {supportEndDate} までは、既存のウェビナーの {supportContent} を取得するためにカスタマーサポートに連絡するか、アカウント管理者に連絡してZoom Webinarsを再度購入することでデータアクセスを復元できます。{dataLossDate} 以降、お使いのアカウントのウェビナーのデータはすべて失われます。"
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "{planName} は {pausedDate} に {pauseDuration} 間、一時停止されます。一時停止期間中は、既存のウェビナーとそのアセットのみ表示できます。いつでも一時停止を解除して、ウェビナーライセンスのサブスクリプションを再開できます。",
            "nonAdmin": "{planName} は {pausedDate} に {pauseDuration} 間、一時停止されます。一時停止期間中は、既存のウェビナーとそのアセットのみ表示できます。一時停止をやめて、ウェビナーライセンスのサブスクリプションを再開するには、アカウント管理者にいつでもご連絡ください。"
          },
          "admin": "{planName} は {pausedDate} に {pauseDuration} 間、一時停止されます。一時停止期間中は、{supportContent} のみ表示できます。いつでも一時停止を解除して、ウェビナーライセンスのサブスクリプションを再開できます。",
          "nonAdmin": "{planName} は {pausedDate} に {pauseDuration} 間、一時停止されます。一時停止期間中は、{supportContent} のみ表示できます。一時停止をやめて、ウェビナーライセンスのサブスクリプションを再開するには、アカウント管理者にいつでもご連絡ください。"
        },
        "active": {
          "webinars": {
            "admin": "{planName} は {pausedDate} から {pauseDuration} 間、一時停止されています。一時停止中は既存のウェビナーのみ表示できます。ウェビナーライセンスのサブスクリプションはいつでも再開できます。",
            "nonAdmin": "{planName} は {pausedDate} から {pauseDuration} 間、一時停止されています。一時停止中は既存のウェビナーのみ表示できます。ウェビナーライセンスのサブスクリプションを再開するには、アカウント管理者にいつでもご連絡ください。"
          },
          "admin": "{planName} は {pauseDuration} 間、一時停止されています。一時停止中は既存のウェビナーの {supportContent} のみ表示できます。ウェビナーライセンスのサブスクリプションはいつでも再開できます。",
          "nonAdmin": "{planName} は {pauseDuration} 間、一時停止されています。一時停止中は既存のウェビナーの {supportContent} のみ表示できます。ウェビナーライセンスのサブスクリプションを再開するには、アカウント管理者にいつでもご連絡ください。"
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "お客様の {planName} ライセンスは {pausedDate} から {pauseDuration} 一時停止されます。引き続きウェビナーをホストするには、一時停止が有効になる前にこのユーザーに有効なライセンスを割り当ててください。このライセンスを引き続き使用するには、一時停止を解除することもできます。",
            "nonAdmin": "お客様の {planName} ライセンスは {pausedDate} から {pauseDuration} 一時停止されます。一時停止期間中に表示できるのは、既存のウェビナーとそのアセットのみです。引き続きウェビナーをホストするには、一時停止が有効になる前にアカウント管理者に連絡してアカウントに有効なライセンスを割り当ててもらう必要があります。"
          },
          "active": {
            "admin": "お客様の {planName} ライセンスは {pausedDate} から {pauseDuration} 一時停止されています。一時停止中に表示できるのは既存のウェビナーのみです。引き続きウェビナーをホストするには、ライセンスのサブスクリプションを再開するか、アカウントに有効なライセンスを割り当ててください。",
            "nonAdmin": "お客様の {planName} ライセンスは {pausedDate} から {pauseDuration} 一時停止されています。一時停止中に表示できるのは既存のウェビナーのみです。一時停止中にウェビナーをホストするには、アカウント管理者に連絡してアカウントに有効なライセンスを割り当ててもらう必要があります。"
          }
        },
        "cancel": {
          "active": {
            "admin": "{planName} ライセンスは {cancelDate} にキャンセルされます。ウェビナーの開催を続けるには、キャンセルが有効になる前にウェビナー ライセンスを再有効化するか、有効なライセンスを割り当ててください。対応しない場合、{supportStartDate} から {supportEndDate} までの猶予期間中にカスタマーサポートに連絡して既存のウェビナー データを取得できます。{dataLossDate} 以降、アカウントに関連するすべてのウェビナー データは完全に削除されます。",
            "nonAdmin": "{planName} ライセンスは {cancelDate} にキャンセルされます。ウェビナーの開催を続けるには、キャンセルが有効になる前にアカウント管理者に連絡し、ウェビナー ライセンスを再有効化するか、有効なライセンスを割り当ててもらってください。対応しない場合、{supportStartDate} から {supportEndDate} までの猶予期間中にカスタマーサポートに連絡して既存のウェビナー データを取得できます。{dataLossDate} 以降、アカウントに関連するすべてのウェビナー データは完全に削除されます。"
          },
          "expired": {
            "admin": "お客様の {planName} ライセンスはキャンセルされました。引き続きウェビナーをホストするには、このユーザーに有効なライセンスを割り当ててください。{supportStartDate} ～ {supportEndDate} の期間中、既存のウェビナーデータを取得するには、カスタマーサポートへご連絡ください。",
            "nonAdmin": "お客様の {planName} ライセンスはキャンセルされました。引き続きウェビナーをホストするには、アカウント管理者に連絡してプロファイルに有効なライセンスを割り当ててもらう必要があります。{supportStartDate} ～ {supportEndDate} の期間中、既存のウェビナーデータを取得するには、カスタマーサポートへご連絡ください。"
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "お客様の {planName} ライセンスは {pausedDate} から {pauseDuration} 一時停止されます。一時停止期間中に表示できるのは、以前のウェビナーの {supportContent} のみです。ウェビナーのアセットに引き続きアクセスするには、一時停止が有効になる前にこのユーザーに有効なライセンスを割り当ててください。このライセンスを引き続き使用するには、一時停止を解除することもできます。",
              "nonAdmin": "お客様の {planName} ライセンスは {pausedDate} から {pauseDuration} 一時停止されます。一時停止期間中に表示できるのは {supportContent} のみです。ウェビナーのアセットに引き続きアクセスするには、アカウント管理者に連絡してプロファイルに有効なライセンスを割り当ててもらう必要があります。"
            },
            "active": {
              "admin": "お客様の {planName} は {pausedDate} から {pauseDuration} 一時停止されています。一時停止中に表示できるのは、既存のウェビナーの {supportContent} のみです。ウェビナーのアセットに引き続きアクセスするには、アカウントに有効なライセンスを割り当ててください。このライセンスサブスクリプションはいつでも再開できます。",
              "nonAdmin": "お客様の {planName} は {pausedDate} から {pauseDuration} 一時停止されています。一時停止中に表示できるのは、既存のウェビナーの {supportContent} のみです。一時停止中にウェビナーをホストするには、アカウント管理者に連絡してアカウントに有効なライセンスを割り当ててもらう必要があります。"
            }
          },
          "cancel": {
            "active": {
              "admin": "ご契約の {planName} は {cancelDate} にキャンセルされます。ウェビナーの主催を継続するには、キャンセルが有効になる前に、アクティブなライセンスをご自身のアカウントに割り当ててください。 {cancelDate} までは、このライセンスを再有効化できます。{supportStartDate} 〜 {supportEndDate} の期間は、カスタマーサポートにお問い合わせのうえ、既存のウェビナーの {supportContent} を取得できます。",
              "nonAdmin": "{planName} ライセンスは {cancelDate} にキャンセルされます。ウェビナーの開催を続けるには、キャンセルが有効になる前にアカウント管理者に連絡し、ウェビナー ライセンスを再有効化するか、有効なライセンスを割り当ててもらってください。対応しない場合、{supportStartDate} から {supportEndDate} までの猶予期間中にカスタマーサポートに連絡して既存のウェビナーの {supportContent} を取得できます。{dataLossDate} 以降、アカウントに関連するすべてのウェビナー データは完全に削除されます。"
            },
            "expired": {
              "admin": "お客様の {planName} ライセンスはキャンセルされました。引き続きウェビナーをホストするには、このユーザーに有効なライセンスを割り当ててください。{supportStartDate} ～ {supportEndDate} の期間中、既存のウェビナーの {supportContent} を取得するには、カスタマーサポートへご連絡ください。",
              "nonAdmin": "お客様の {planName} ライセンスはキャンセルされました。引き続きウェビナーをホストするには、アカウント管理者に連絡してプロファイルに有効なライセンスを割り当ててもらう必要があります。{supportStartDate} ～ {supportEndDate} の期間中、既存のウェビナーの {supportContent} を取得するには、カスタマーサポートへご連絡ください。"
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "データ",
        "recordingsAndTranscripts": "レコーディングと文字起こし",
        "reports": "レポート",
        "summaries": "要約",
        "dashboard": "ダッシュボード"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "過去のウェビナーのレコーディングと文字起こし",
          "reports": "過去のウェビナーのレポート",
          "summaries": "過去のウェビナーの要約",
          "dashboard": "過去のウェビナーのダッシュボード",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "プランを再アクティベート",
    "purchasePlan": "プランを購入",
    "removePause": "一時停止を解除",
    "resumeSubscription": "サブスクリプションを再開",
    "month": "か月",
    "months": "か月",
    "assignLicense": "ライセンスを割り当てる"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "了解"
    },
    "coachMark": {
      "tipsTitle": "アドレス帳は顧客ディレクトリに名称変更されます",
      "tipsContent": "2026 年 10 月のリリースで、用途をより正確に表すため、アドレス帳を顧客ディレクトリに名称変更します。既存の機能、権限、ワークフローはすべて同じです。これまでどおり、顧客リスト（アドレス帳）と連絡先を管理できます。"
    }
  },
  "zoomPrivacy": {
    "agreeMain": "当社は規約と方針を更新しています。",
    "agreeSub": "引き続きZoomを使用することによって、お客さまは更新された<a href=\"https://www.zoom.us/terms\" target=\"_blank\">サービス規約</a>と<a href=\"https://www.zoom.us/privacy\" target=\"_blank\">プライバシー保護方針</a>に同意いただいたことになります。",
    "continue": "続ける"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "メインアカウントに戻る",
      "backLinkedAccount": "リンク済みアカウントに戻る",
      "backMyAccount": "マイアカウントに戻る",
      "myAccount": "マイアカウント"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "カスタム AI Companion がアカウントで利用できるようになりました",
      "desc": "アカウントで利用できるカスタム AI Companion の機能の一部をご紹介します。",
      "studioTitle": "AI Studio",
      "studioDesc": "組織向けに AI Companion の体験をカスタマイズできます。",
      "integrationsTitle": "サードパーティ連携",
      "integrationsDesc": "サードパーティ アプリを活用してワークフローを効率化します。",
      "clipsTitle": "Zoom Clips のカスタム アバター",
      "clipsDesc": "ユーザーがクリップで使用する AI アバターをパーソナライズできるようにします。"
    },
    "coachMark": {
      "licenseTitle": "割り当て可能なカスタム AI Companion ライセンスが {0} あります",
      "licenseDesc": "<b>ユーザー管理</b>でこれらのライセンスを割り当てると、ユーザーが高度な AI Companion 機能を使い始められます。",
      "settingTitle": "アカウントのカスタム AI Companion 設定を確認する",
      "settingDesc": "<b>アカウント設定</b>で各カスタム AI 機能の設定を構成します。<a href=\"/account/setting?tab=aicompanion\">設定へ移動</a>",
      "groupSettingTitle": "グループのカスタム AI 設定を確認する",
      "groupSettingDesc": "<b>グループ設定</b>で各カスタム AI 機能の設定を構成します。<a href=\"/account/group\">設定へ移動</a>"
    },
    "common": {
      "learnMore": "詳細はこちら",
      "quickTour": "クイックツアーを開始",
      "remindLater": "後で通知",
      "dismiss": "閉じる",
      "next": "次へ",
      "back": "戻る",
      "gotIt": "了解",
      "goToSetting": "設定へ移動"
    },
    "aiPanelToast": "<b>Zoom Workplace の AI パネル</b>設定をオンにすると、カスタム AI Companion のすべての機能を使い始められます。"
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "了解",
      "next": "次へ",
      "remindMeLater": "後で通知",
      "waffleMenuTitle": "新しい Zoom ウェブ体験へようこそ",
      "waffleMenuDesc": "新しい<b>製品メニュー</b>で、どこからでも Zoom 製品にアクセスできます。",
      "profileMenuTitle": "マイアカウント",
      "profileMenuDesc": "<b>マイアカウント</b>でプロフィールと個人設定を確認できます。",
      "personalTitle": "必要なものすべてにアクセス",
      "personalDesc": "<b>マイアカウント</b>には、プロフィール、設定、ミーティングの文字起こしなどが含まれます。",
      "adminCenterTitle": "管理センターで組織の設定を確認",
      "adminCenterDesc": "新しい<b>管理センター</b>では、組織全体の製品を構成し、設定を調整できます。",
      "adminMenuForTitle": "管理センターを使いこなす",
      "adminMenuForAccountSettings": "<b>設定</b>では、組織内の全員に適用されるデフォルトの製品設定にアクセスできます。",
      "adminMenuForContentManagementItem": "<b>コンテンツ管理</b>では、ユーザーが生成したすべてのコンテンツを管理できます。",
      "adminMenuForConfigureProductsItem": "<b>製品構成</b>では、製品のセットアップと管理者タスクを完了できます。",
      "adminMenuForNoItems": "新しい管理センターでは、アカウント設定と製品をより簡単にアクセスして管理できます。よく使う項目をピン留めして、すばやくアクセスすることもできます。",
      "tryNewExperience": "新しい体験を試す",
      "tryNewExperienceDetail": "ぜひお試しください。いつでもこのクラシック体験に戻せます。",
      "tryNewExperienceTitle": "Zoom Webの新しいデザイン！"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. All rights reserved.",
    "terms": "利用規約",
    "privacy": "プライバシー",
    "trust_center": "トラストセンター",
    "acceptable_use_guidelines": "利用ガイドライン",
    "legal": "法的情報",
    "do_not_sell_my_personal_information": "プライバシーに関する選択",
    "cookie_preferences": "Cookie の設定",
    "pricing": "プランと料金",
    "feedback": "フィードバック",
    "contact_us": "お問い合わせ"
  },
  "termChange": {
    "changeTerm": {
      "title": "更新期間変更に関する合意",
      "quoteNumbers": "修正済み注文書 - {0}",
      "content1": "本規約に同意することにより、お客様は、Zoom Communications, Inc.（「Zoom」）とお客様との間のすべての注文書について、既存のサブスクリプション更新期間を変更し、コミットメント期間を月単位の更新期間から {0} に変更することに同意します。このコミットメントと引き換えに、Zoom は最初の新しい更新期間中、お客様の現行価格を維持することに同意します。",
      "content2": "お客様は、以下の「承諾する」をクリックした時点で新しい更新期間 {0} が適用され、当該新しい更新期間がお客様の現在の月単位更新期間の終了日の翌日から開始されることを理解します。この新しい更新期間は、現在 Zoom との間で有効なすべての注文書に適用され、これらの注文書に基づく将来のすべての更新期間も同じ長さとなります。",
      "content3": "お客様は、変更されるのは更新期間のみであり、現在 Zoom との間で有効な各注文書のその他すべての条項は変更されず、その条項に従い引き続き完全に効力を有することを認めます。",
      "content4": "さらに、これがお客様と Zoom との間の契約上のコミットメントであることに同意します。",
      "agreementText": "「承諾する」をクリックすることにより、お客様はこの変更をお客様に代わって行う権限を有すること、およびお客様が上記の条項に同意することを証明します。",
      "IDecline": "承諾しない",
      "IAccept": "承諾する"
    },
    "unableToChangeTerm": {
      "title": "更新期間を変更できません",
      "content": "ご利用のアカウントは更新期間を更新する対象ではありません。誤りである場合は<a target=\"_blank\" href=\"{0}\">お問い合わせ</a>ください。",
      "acceptedTitle": "更新期間が延長されました",
      "acceptedContent": "更新条件は以前に承諾済みです。追加の操作は不要です。",
      "GotIt": "了解"
    },
    "termLengthUpdated": "更新期間の長さが {0} か月に更新されました。",
    "termLengthUnchanged": "期間の長さは変更されていません。",
    "errorInfo": "サーバー エラーが発生しました。もう一度お試しください。",
    "x12MonthTerm": "12 か月の期間",
    "x24MonthTerm": "24 か月の期間",
    "x12MonthTermPlural": "12 か月",
    "x24MonthTermPlural": "24 か月"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "アカウントは{0}に<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">新しいZoomウェブエクスペリエンス</a>へ更新される予定です。",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">更新時期を確認</a>"
    },
    "completed": {
      "content": "新しいZoomウェブエクスペリエンスがアカウントのすべてのユーザーに対して有効になりました。ユーザーは次回のログイン時に更新されたインターフェースを確認できます。"
    }
  }
}
